import { Language, I18nType } from "@zkt/eb-utility";

export const texts = {
  [Language.EN_US]: {
    placeholder: "Search",
  },
  [Language.ZH_CN]: {
    placeholder: "可按菜单名称搜索",
  },
};

export type I18nTextType = I18nType<typeof texts>;
